module.exports = __webpack_public_path__ + "img/header_3.c4dbd1dd.jpg";